var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDarkBlueArrow = function SvgDarkBlueArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12.998a.97.97 0 0 1 .311-.707c.2-.187.47-.293.751-.293h12.31l-4.563-4.291a.998.998 0 0 1-.23-.325.95.95 0 0 1 0-.766.998.998 0 0 1 .23-.325 1.07 1.07 0 0 1 .345-.217 1.121 1.121 0 0 1 1.16.217l6.374 6a1 1 0 0 1 .23.324.95.95 0 0 1-.23 1.09l-6.374 6a1.07 1.07 0 0 1-.345.217 1.12 1.12 0 0 1-1.16-.217.972.972 0 0 1-.311-.708.95.95 0 0 1 .08-.383.998.998 0 0 1 .231-.325l4.562-4.291H4.562c-.281 0-.552-.105-.75-.293a.97.97 0 0 1-.312-.707Z",
    fill: "#1D76BB"
  })));
};

export default SvgDarkBlueArrow;